const config = {
    position: 'bottom-center',
    newestOnTop: true,
    draggablePercent: 50,
};

export default config;
